import { render } from "./SideMenu.vue?vue&type=template&id=0d7ef637&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=0d7ef637&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7ef637"],['__file',"src/components/scan/parts/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d7ef637"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d7ef637', __exports__)) {
    console.log('reload')
    api.reload('0d7ef637', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=0d7ef637&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0d7ef637', render)
  })

}


export default __exports__